import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Component = () => {
  const [email, setEmail] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [devResetUrl, setDevResetUrl] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    setSaving(true);
    setError('');
    setMessage('');
    setDevResetUrl('');
    try {

      const Factory = require( '../../../records/auth' );

      const response = await Factory.requestPasswordReset({ email: email.trim() });
      setMessage(response.message || 'If the account exists, a reset link has been generated.');
      if (response.resetUrl) {
        setDevResetUrl(response.resetUrl);
      }
    } catch (err) {
      setError(err?.response?.data?.message || err.message || 'Unable to request password reset.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="auth-shell">
      <form className="card auth-card stack" onSubmit={handleSubmit}>
        <div className="stack-sm">
          <h1 className="page-title">Forgot password</h1>
          <p className="page-subtitle">Enter your account email to generate a reset link.</p>
        </div>

        {error ? <p className="error-text">{error}</p> : null}
        {message ? <p>{message}</p> : null}
        {devResetUrl ? <p className="dev-hint">Dev reset link: {devResetUrl}</p> : null}

        <label>
          Email
          <input
            autoComplete="email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </label>

        <button className="button-primary" disabled={saving} type="submit">
          {saving ? 'Submitting...' : 'Send reset link'}
        </button>

        <Link className="inline-link" to="/login">Back to sign in</Link>
      </form>
    </div>
  );
};

export default Component;
